import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7127fbec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UpdatePassword" }

import LfForm from '@/components/lf-form.vue'
import { modalConfig } from './config/modal.config'
import { ref } from 'vue'
import { updatePassword } from '@/service/account/account'
import { useStore } from '@/store'
import { getKeyRequest } from '@/service/common/common'
import { JSEncrypt } from 'jsencrypt'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdatePassword',
  setup(__props) {

const formData = ref<any>({})
const confirmPasswordItem = modalConfig.formItems.find(
  (item) => item.field === 'confirmPassword'
)

const validateComfirmPasswrod = (rule: any, value: any, callback: any) => {
  if (value !== formData.value.password) {
    callback(new Error('两次密码输入不一致'))
  } else {
    const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@_!#$%^&*])|(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[@_!#$%^&*])|(?=.*[a-z])(?=.*\d)(?=.*[@_!#$%^&*])|(?=.*[A-Z])(?=.*\d)(?=.*[@_!#$%^&*])/;
    if(!reg.test(value)){
      callback(new Error('输入的密码必须包含数字、大小写、符号（常用的有@_等），至少两种'))
    }
    callback()
  }
}

confirmPasswordItem?.rules.push({
  validator: validateComfirmPasswrod,
  trigger: 'blur'
})

const store = useStore()
const userInfo = store.state.login.userInfo

const confirmLoading = ref(false)

const lfFormRef = ref<InstanceType<typeof LfForm>>()

const handleSubmit = () => {
  confirmLoading.value = true
  lfFormRef.value?.validate(async (isValid) => {
    if (isValid) {
      confirmLoading.value = false
      const key = await getKeyRequest()
      //新建JSEncrypt对象
      const encryptor = new JSEncrypt()
      // 设置公钥
      encryptor.setPublicKey(key)
      const queryInfo = { password: '', oldPassword: '', confirmPassword: '' }
      // 加密密码
      queryInfo.password = encryptor.encrypt(formData.value.password).toString()
      queryInfo.oldPassword = encryptor
        .encrypt(formData.value.oldPassword)
        .toString()
      queryInfo.confirmPassword = encryptor
        .encrypt(formData.value.confirmPassword)
        .toString()
      await updatePassword(userInfo.id, queryInfo)
      ElMessage.success({
        message: '密码修改成功，请重新登录',
        type: 'success',
        duration: 3 * 1000
      })
      store.dispatch('login/resetToken').then(() => {
        location.reload()
      })
    } else {
      confirmLoading.value = false
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "card",
      shadow: "alway",
      "body-style": { padding: '20px' }
    }, {
      default: _withCtx(() => [
        _createVNode(LfForm, _mergeProps(_unref(modalConfig), {
          modelValue: formData.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event)),
          ref_key: "lfFormRef",
          ref: lfFormRef
        }), null, 16, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit,
          loading: confirmLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})